// FloatAnimation.js
'use strict';
import { keyframes } from 'styled-components';

const createFloatAnimation = maxHeight => keyframes`
  0% {
    opacity: 1;
    transform: translate(0, 0) rotate(0deg) scale(0.8);
  }
  10% {
    opacity: 1;
    transform: translate(-3px, -${maxHeight * 0.1}px) rotate(1deg) scale(0.9);
  }
  20% {
    opacity: 1;
    transform: translate(2px, -${maxHeight * 0.2}px) rotate(-1deg) scale(1);
  }
  30% {
    opacity: 1;
    transform: translate(-4px, -${maxHeight * 0.3}px) rotate(2deg) scale(0.95);
  }
  40% {
    opacity: 1;
    transform: translate(3px, -${maxHeight * 0.4}px) rotate(-1deg) scale(0.9);
  }
  50% {
    opacity: 0.9;
    transform: translate(-2px, -${maxHeight * 0.5}px) rotate(1deg) scale(0.85);
  }
  60% {
    opacity: 0.8;
    transform: translate(4px, -${maxHeight * 0.6}px) rotate(-2deg) scale(0.8);
  }
  70% {
    opacity: 0.6;
    transform: translate(-3px, -${maxHeight * 0.7}px) rotate(1deg) scale(0.75);
  }
  80% {
    opacity: 0.4;
    transform: translate(2px, -${maxHeight * 0.8}px) rotate(-1deg) scale(0.7);
  }
  90% {
    opacity: 0.2;
    transform: translate(-1px, -${maxHeight * 0.9}px) rotate(0deg) scale(0.65);
  }
  100% {
    opacity: 0;
    transform: translate(0, -${maxHeight}px) rotate(0deg) scale(0.6);
  }
`;

export default createFloatAnimation;
